import _get from "lodash/get";
import { css } from 'styled-components';
import baseTheme from './baseTheme';

var initialLinkStyles = function initialLinkStyles() {
  return css(["&,&:hover,&:focus,&:active{color:", ";text-decoration:none;}"], function (_ref) {
    var theme = _ref.theme;
    return _get(theme, 'base.colors.dark', baseTheme.base.colors.dark);
  });
};

export default initialLinkStyles;